module.exports = __webpack_public_path__ + "static/img/p08.5157a90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comic/001/p08.jpg
// module id = 121
// module chunks = 0